exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clanblack[data-v-20bfa2e9]{font-family:ClanFFBlack!important;font-weight:400}.clanpro[data-v-20bfa2e9]{font-family:ClanPro!important;font-weight:400}.clanprobold[data-v-20bfa2e9]{font-family:ClanProBold!important;font-weight:400}.clanprobook[data-v-20bfa2e9],.filters .search-bar input[data-v-20bfa2e9]{font-family:ClanProBook!important;font-weight:400}.filters[data-v-20bfa2e9]{border:1px solid #e9e9e9;padding:6px 20px;border-radius:25px}.filters .search-bar[data-v-20bfa2e9]{color:#999}.filters .search-bar input[data-v-20bfa2e9]{border:none}.filters .search-bar button.btn[data-v-20bfa2e9]{color:inherit;background:none;border:none}button.btn[data-v-20bfa2e9]{padding:0;height:40px;width:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20bfa2e9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Role/RoleAuthorization.vue
// module id = 811
// module chunks = 0